import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <section className="bg-slate-900 py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-amber-400/10 rounded-full flex items-center justify-center">
              <Shield className="w-8 h-8 text-amber-400" />
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>Privacy Policy</h1>
          <p className="text-slate-300 text-lg">Effective October 16, 2026</p>
        </div>
      </section>
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="space-y-8 text-slate-700 leading-relaxed">
            <p>Anderson & Anderson Insurance LLC ('we,' 'our,' or 'the agency') respects your privacy. This policy explains what information we collect through a2insure.com, how we use it, and the choices you have.</p>
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Information we collect</h2>
              <p>When you submit a quote request, contact form, or appointment booking on this site, we collect the information you provide: your name, email address, phone number, the type of insurance you are asking about, and anything you write in your message. We also collect standard website analytics (pages visited, device and browser type) through cookies and similar tools that help us understand how the site is used.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>How we use your information</h2>
              <p>We use the information you submit to respond to your inquiry, prepare quotes, schedule appointments, and service your insurance needs. With your knowledge, information needed to quote or service a policy is shared with insurance carriers and partners. We do not sell your personal information.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Cookies</h2>
              <p>This site uses cookies and analytics services to improve the website and measure traffic. You can disable cookies in your browser settings; the site will still work.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>How we protect it</h2>
              <p>We use reasonable administrative and technical safeguards for the information submitted through this site. No internet transmission is completely secure, so please do not send sensitive documents (such as full Social Security numbers or bank details) through the website forms.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Your choices</h2>
              <p>You may ask us at any time what personal information we hold about you, ask us to correct it, or ask us to delete it, by contacting us at customerservice@a2insure.com or (219) 779-7040.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Changes to this policy</h2>
              <p>We may update this policy from time to time; the current version will always be posted on this page. Effective October 16, 2026. Anderson & Anderson Insurance LLC, 10971 Four Seasons Pl, Ste 216, Crown Point, IN 46307.</p>
            </div>
          </div>
          <div className="mt-12 pt-8 border-t border-slate-200 text-center">
            <Link to="/" className="inline-flex items-center px-6 py-3 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors">Back to Home</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
